import { useRef } from "react";
import { keepIfEqual } from "./keep-if-equal";

/**
 * Returns the previous reference while the new value is structurally equal, so a value
 * rebuilt on every render (a mapped list) does not defeat memoized children.
 * Повертає попереднє посилання, доки нове значення рівне за вмістом.
 */
export function useStableValue<T>(value: T): T {
  const ref = useRef(value);
  ref.current = keepIfEqual(ref.current, value);
  return ref.current;
}
